import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import PersonDetailsPage from './PersonDetailsPage';
import { OFFICER_DETAILS } from '../../utils/constants';
import { addressSelector } from '../../infrastructure/address';
import {
  savePersonDetails,
  officerSelector,
  onOfficerValueChange
} from '../../infrastructure/officer';
import { selectors as caseSelector } from '../../infrastructure/cases';

const personDetailsSection = ({
  savePersonDetails,
  currentOfficerNumber,
  isSoleTrader,
  onOfficerValueChange,
  ...props
}) => {
  return (
    <PersonDetailsPage
      savePersonDetails={savePersonDetails}
      currentOfficerNumber={currentOfficerNumber}
      onOfficerValueChange={onOfficerValueChange}
      {...props}
      isSoleTrader={isSoleTrader}
      showSubmit
    />
  );
};

personDetailsSection.propTypes = {
  isSoleTrader: PropTypes.bool,
  currentOfficerNumber: PropTypes.number,
  savePersonDetails: PropTypes.func.isRequired
};

const actionCreators = {
  savePersonDetails,
  onOfficerValueChange
};

const mapStateToProps = state => ({
  addressHistory: addressSelector.noOfAddresses(
    state,
    officerSelector.getOfficerDataLength(state, OFFICER_DETAILS)
  ),
  currentOfficerNumber: officerSelector.getOfficerDataLength(state, OFFICER_DETAILS),
  isSoleTrader: caseSelector.isSoleTrader(state)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(personDetailsSection);
